import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui";
import { cn } from "@/lib/utils";

interface RegionCodeBadgeProps {
  code: string | null | undefined;
  className?: string;
}

export function RegionCodeBadge({ code, className }: RegionCodeBadgeProps) {
  const { t } = useTranslation("common");
  if (!code) {
    return (
      <span className={cn("text-sm text-surface-400", className)}>
        {t("region.unknown")}
      </span>
    );
  }
  return (
    <Badge variant="default" size="sm" className={cn("tracking-wide", className)}>
      {code}
    </Badge>
  );
}
